// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"55ac75b0","453":"1b9726e4","777":"dd17130b"}[chunkId] + ".chunk.js";
};